module.exports = __webpack_public_path__ + "img/6.1d028856.svg";